import { render, staticRenderFns } from "./FundByYearStatistics.vue?vue&type=template&id=c17f095c&scoped=true&"
import script from "./FundByYearStatistics.vue?vue&type=script&lang=js&"
export * from "./FundByYearStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17f095c",
  null
  
)

export default component.exports